import {getQuery, postQuery, putQuery} from "@/modules/common/utils";

const createScheduledPayment = async (params) => {
  params.new_api = true
  return postQuery('/business/payments/v1/scheduled_payments_rules', params).then((res) => res.data)
};

const editScheduledPayment = async (uid, params) => {
  params.new_api = true
  return putQuery(`/business/payments/v1/scheduled_payments_rules/${uid}`, params).then((res) => res.data)
};

const getScheduledPayments = async (scheduledPaymentsUid) => {
  return getQuery(`/business/payments/v1/scheduled_payments_rules/${scheduledPaymentsUid}`, {new_api: true}).then((res) => res.data)
}

const getFilteredScheduledPayments = async (params) => {
  return getQuery(`/business/payments/v1/scheduled_payments_rules`, {...params, new_api: true}).then((res) => res.data)
}

export default {
  createScheduledPayment,
  editScheduledPayment,
  getScheduledPayments,
  getFilteredScheduledPayments,
}


